const mediaItems = [
  {
    id: 1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20with%20paparazzi%20camera%20flashes%20and%20celebrity%20silhouette%2C%20warm%20street%20lights%2C%20breaking%20news%20aesthetic%2C%20red%20and%20dark%20tones%2C%20cinematic%20photography%2C%20entertainment%20news%20style&width=600&height=340&seq=media-thumb-1&orientation=landscape',
    title: '独家实拍：某顶流深夜密会全程跟拍',
    duration: '03:28',
    views: '89.6万',
    tag: '实拍',
  },
  {
    id: 2,
    thumbnail: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20accident%20moment%20with%20dramatic%20lighting%2C%20shocked%20expression%20abstract%2C%20red%20alert%20atmosphere%2C%20breaking%20news%20style%2C%20warm%20and%20dark%20contrast%2C%20editorial%20photography&width=600&height=340&seq=media-thumb-2&orientation=landscape',
    title: '直播间口误全记录：一句话毁掉千万合约',
    duration: '05:12',
    views: '67.3万',
    tag: '翻车',
  },
  {
    id: 3,
    thumbnail: 'https://readdy.ai/api/search-image?query=TV%20studio%20drama%20with%20host%20and%20guest%20in%20heated%20argument%2C%20abstract%20style%2C%20dramatic%20red%20lighting%2C%20reality%20show%20aesthetic%2C%20bold%20contrast%2C%20entertainment%20news%20photography&width=600&height=340&seq=media-thumb-3&orientation=landscape',
    title: '综艺录制现场突发：嘉宾当场翻脸离场',
    duration: '02:45',
    views: '54.8万',
    tag: '现场',
  },
  {
    id: 4,
    thumbnail: 'https://readdy.ai/api/search-image?query=Press%20conference%20with%20multiple%20microphones%20and%20dramatic%20lighting%2C%20brand%20crisis%20scene%2C%20red%20and%20dark%20tones%2C%20corporate%20drama%20aesthetic%2C%20breaking%20news%20style%2C%20editorial%20composition&width=600&height=340&seq=media-thumb-4&orientation=landscape',
    title: '品牌紧急发布会：三家品牌同时宣布解约',
    duration: '04:56',
    views: '42.1万',
    tag: '发布会',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          吃瓜视频<i className="ri-vidicon-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">热门爆料视频精选</p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200/50 transition-colors">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-11 h-11 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs text-white bg-black/60 px-1.5 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="text-xs font-semibold text-white bg-primary-500/90 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-play-circle-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}